import { render, staticRenderFns } from "./CreditsConsumed.vue?vue&type=template&id=143905b4&"
import script from "./CreditsConsumed.vue?vue&type=script&lang=js&"
export * from "./CreditsConsumed.vue?vue&type=script&lang=js&"
import style0 from "./CreditsConsumed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports